var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoResults(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 425.18,
    height: 423.792,
    viewBox: "0 0 425.18 423.792",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2379",
    "data-name": "Rect\\xE1ngulo 2379",
    width: 390.395,
    height: 390.396,
    rx: 144,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4216",
    "data-name": "Trazado 4216",
    d: "M182.566,194.511v32.627a18.06,18.06,0,0,0,18.062,18.06h3.8a18.061,18.061,0,0,0,18.062-18.06V194.511Z",
    transform: "translate(-182.566 -194.511)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2612",
    "data-name": "Grupo 2612",
    transform: "translate(-23.441)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2605",
    "data-name": "Grupo 2605",
    transform: "translate(35.866 28.669)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2604",
    "data-name": "Grupo 2604",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4165",
    "data-name": "Trazado 4165",
    d: "M259.022,25.32l-94.846-6.868c-90.049,0-132.5,79.869-132.5,169.917v64.3a163.049,163.049,0,0,0,163.048,163.05h64.3c90.049,0,163.048-20.873,163.048-110.923V188.368c0-90.048-35.139-169.917-125.188-169.917",
    transform: "translate(-31.676 -25.32)",
    fill: "#88c0ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4166",
    "data-name": "Trazado 4166",
    d: "M291.38,295.49h0a36.625,36.625,0,0,0-18.625-47.2,24.064,24.064,0,0,0-20.057,0,36.626,36.626,0,0,0-18.624,47.2c10.511,25.621,46.795,25.621,57.306,0",
    transform: "translate(-5.266 3.885)",
    fill: "#88c0ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4167",
    "data-name": "Trazado 4167",
    d: "M291.38,295.49h0a36.625,36.625,0,0,0-18.625-47.2,24.064,24.064,0,0,0-20.057,0,36.626,36.626,0,0,0-18.624,47.2C244.585,321.111,280.869,321.111,291.38,295.49Z",
    transform: "translate(-5.266 3.885)",
    fill: "none",
    stroke: "#007dce",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4168",
    "data-name": "Trazado 4168",
    d: "M261.7,340.623v-41.5a24.278,24.278,0,0,1,24.278-24.278h4.008",
    transform: "translate(-1.248 7.687)",
    fill: "none",
    stroke: "#007dce",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4169",
    "data-name": "Trazado 4169",
    d: "M258.422,340.623v-41.5a24.279,24.279,0,0,0-24.278-24.278h-2.707",
    transform: "translate(-5.252 7.687)",
    fill: "none",
    stroke: "#007dce",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4170",
    "data-name": "Trazado 4170",
    d: "M261.7,310.341c0-8.253,3.234-15.545,8.176-19.932s11.773-2.839,15.383,3.319",
    transform: "translate(-1.248 9.415)",
    fill: "none",
    stroke: "#007dce",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4171",
    "data-name": "Trazado 4171",
    d: "M232.339,286.484c1.39,1.345,7.77,1.994,11.391-.476,2.168-1.478,3.135-4.283,2.87-8.231",
    transform: "translate(-5.132 8.075)",
    fill: "none",
    stroke: "#007dce",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4172",
    "data-name": "Trazado 4172",
    d: "M248.9,264.294c3.289,2.724,8.56,2.276,13.925-.641s9.744-9.46,9.931-14.68",
    transform: "translate(-2.942 4.265)",
    fill: "none",
    stroke: "#007dce",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4173",
    "data-name": "Trazado 4173",
    d: "M272.467,288.614c4.2-3.948,9.234-5.056,14.869-2.306",
    transform: "translate(0.176 9.003)",
    fill: "none",
    stroke: "#007dce",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4174",
    "data-name": "Trazado 4174",
    d: "M242.809,284.77c3.71,4.808,1.3,10.283-5.248,12.375",
    transform: "translate(-4.441 9)",
    fill: "none",
    stroke: "#007dce",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4175",
    "data-name": "Trazado 4175",
    d: "M265.056,285.383c4.624-7.362,14.635-6.634,16.829.028",
    transform: "translate(-0.804 8.387)",
    fill: "none",
    stroke: "#007dce",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4176",
    "data-name": "Trazado 4176",
    d: "M261.192,262.354a20.014,20.014,0,0,1-9.321,26.167",
    transform: "translate(-2.548 6.035)",
    fill: "none",
    stroke: "#007dce",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4177",
    "data-name": "Trazado 4177",
    d: "M242.074,252.656c9.452,7.322,11.967,21.163,5.926,31.113",
    transform: "translate(-3.844 4.752)",
    fill: "none",
    stroke: "#007dce",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4178",
    "data-name": "Trazado 4178",
    d: "M261.663,272.207a14.314,14.314,0,0,1,19.588,3.319",
    transform: "translate(-1.253 7.007)",
    fill: "none",
    stroke: "#007dce",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2370",
    "data-name": "Rect\\xE1ngulo 2370",
    width: 48.13,
    height: 48.13,
    transform: "translate(-24.064 332.426)",
    fill: "#cde0ee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4179",
    "data-name": "Trazado 4179",
    d: "M323.652,272.381H309.726a21.661,21.661,0,1,1,0-43.322h13.926a21.661,21.661,0,1,1,0,43.322",
    transform: "translate(2.239 1.631)",
    fill: "#88c0ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4180",
    "data-name": "Trazado 4180",
    d: "M323.652,272.381H309.726a21.661,21.661,0,1,1,0-43.322h13.926a21.661,21.661,0,1,1,0,43.322Z",
    transform: "translate(2.239 1.631)",
    fill: "none",
    stroke: "#007dce",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4181",
    "data-name": "Trazado 4181",
    d: "M345.531,266.457v7.957A15.886,15.886,0,0,1,329.644,290.3H324.9v-8.143H312.984v18.589h-.9a15.887,15.887,0,0,1-15.887-15.887V276.9H288.3v6.575a24.822,24.822,0,0,0,24.684,24.82v33.435H324.9V297.855h3.7a24.823,24.823,0,0,0,24.823-24.823v-6.575Z",
    transform: "translate(2.27 6.578)",
    fill: "#88c0ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4182",
    "data-name": "Trazado 4182",
    d: "M345.531,266.457v7.957A15.886,15.886,0,0,1,329.644,290.3H324.9v-8.143H312.984v18.589h-.9a15.887,15.887,0,0,1-15.887-15.887V276.9H288.3v6.575a24.822,24.822,0,0,0,24.684,24.82v33.435H324.9V297.855h3.7a24.823,24.823,0,0,0,24.823-24.823v-6.575Z",
    transform: "translate(2.27 6.578)",
    fill: "none",
    stroke: "#007dce",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4183",
    "data-name": "Trazado 4183",
    d: "M331.031,333.866h-27.8a7.943,7.943,0,0,1,7.943-7.943h11.916A7.943,7.943,0,0,1,331.031,333.866Z",
    transform: "translate(4.245 14.444)",
    fill: "#88c0ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4184",
    "data-name": "Trazado 4184",
    d: "M331.031,333.866h-27.8a7.943,7.943,0,0,1,7.943-7.943h11.916A7.943,7.943,0,0,1,331.031,333.866Z",
    transform: "translate(4.245 14.444)",
    fill: "none",
    stroke: "#007dce",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4185",
    "data-name": "Trazado 4185",
    d: "M294.336,285.383H275.7a15.048,15.048,0,1,1,0-30.1h18.634a15.048,15.048,0,1,1,0,30.1",
    transform: "translate(-1.387 5.1)",
    fill: "#88c0ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4186",
    "data-name": "Trazado 4186",
    d: "M294.336,285.383H275.7a15.048,15.048,0,1,1,0-30.1h18.634a15.048,15.048,0,1,1,0,30.1Z",
    transform: "translate(-1.387 5.1)",
    fill: "none",
    stroke: "#007dce",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4187",
    "data-name": "Trazado 4187",
    d: "M321.794,286.461h-7.743a16.813,16.813,0,0,1-16.813-16.813v-3.963a16.814,16.814,0,0,1,16.813-16.814h7.743a16.814,16.814,0,0,1,16.813,16.814v3.963a16.813,16.813,0,0,1-16.813,16.813",
    transform: "translate(3.453 4.251)",
    fill: "#88c0ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_2371",
    "data-name": "Rect\\xE1ngulo 2371",
    d: "M14.849,0H26.52A14.849,14.849,0,0,1,41.369,14.849v7.892a14.85,14.85,0,0,1-14.85,14.85H14.85A14.85,14.85,0,0,1,0,22.741V14.849A14.849,14.849,0,0,1,14.849,0Z",
    transform: "translate(300.69 253.121)",
    fill: "none",
    stroke: "#007dce",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4188",
    "data-name": "Trazado 4188",
    d: "M347.806,259.572H334a12.614,12.614,0,0,1,0-25.228h13.8a12.614,12.614,0,0,1,0,25.228",
    transform: "translate(6.648 2.33)",
    fill: "#88c0ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4189",
    "data-name": "Trazado 4189",
    d: "M347.806,259.572H334a12.614,12.614,0,0,1,0-25.228h13.8a12.614,12.614,0,0,1,0,25.228Z",
    transform: "translate(6.648 2.33)",
    fill: "none",
    stroke: "#007dce",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4190",
    "data-name": "Trazado 4190",
    d: "M349.807,279.164H339.434a9.479,9.479,0,1,1,0-18.959h10.373a9.479,9.479,0,0,1,0,18.959",
    transform: "translate(7.781 5.751)",
    fill: "#88c0ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4191",
    "data-name": "Trazado 4191",
    d: "M349.807,279.164H339.434a9.479,9.479,0,1,1,0-18.959h10.373a9.479,9.479,0,0,1,0,18.959Z",
    transform: "translate(7.781 5.751)",
    fill: "none",
    stroke: "#007dce",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4192",
    "data-name": "Trazado 4192",
    d: "M317.549,238.135h-6.9a10.932,10.932,0,0,1,0-21.864h6.9a10.932,10.932,0,0,1,0,21.864",
    transform: "translate(3.781 -0.061)",
    fill: "#88c0ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4193",
    "data-name": "Trazado 4193",
    d: "M317.549,238.135h-6.9a10.932,10.932,0,0,1,0-21.864h6.9a10.932,10.932,0,0,1,0,21.864Z",
    transform: "translate(3.781 -0.061)",
    fill: "none",
    stroke: "#007dce",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4194",
    "data-name": "Trazado 4194",
    d: "M300.753,248.191H290.31a9.827,9.827,0,1,1,0-19.653h10.443a9.827,9.827,0,1,1,0,19.653",
    transform: "translate(1.236 1.562)",
    fill: "#88c0ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4195",
    "data-name": "Trazado 4195",
    d: "M300.753,248.191H290.31a9.827,9.827,0,1,1,0-19.653h10.443a9.827,9.827,0,1,1,0,19.653Z",
    transform: "translate(1.236 1.562)",
    fill: "none",
    stroke: "#007dce",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4196",
    "data-name": "Trazado 4196",
    d: "M233.556,200.03H6.661A5.661,5.661,0,0,1,1,194.369V105.25a5.661,5.661,0,0,1,5.661-5.661H236.953a2.264,2.264,0,0,1,2.265,2.265v92.515a5.662,5.662,0,0,1-5.661,5.661",
    transform: "translate(-35.734 -15.496)",
    fill: "#88c0ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4197",
    "data-name": "Trazado 4197",
    d: "M233.556,200.03H6.661A5.661,5.661,0,0,1,1,194.369V105.25a5.661,5.661,0,0,1,5.661-5.661H236.953a2.264,2.264,0,0,1,2.265,2.265v92.515A5.662,5.662,0,0,1,233.556,200.03Z",
    transform: "translate(-35.734 -15.496)",
    fill: "none",
    stroke: "#007dce",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2372",
    "data-name": "Rect\\xE1ngulo 2372",
    width: 228.352,
    height: 163.775,
    transform: "translate(-34.734 184.535)",
    fill: "#88c0ec"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2373",
    "data-name": "Rect\\xE1ngulo 2373",
    width: 228.352,
    height: 163.775,
    transform: "translate(-34.734 184.535)",
    fill: "none",
    stroke: "#007dce",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2374",
    "data-name": "Rect\\xE1ngulo 2374",
    width: 66.763,
    height: 131.842,
    transform: "translate(-20.404 216.468)",
    fill: "none",
    stroke: "#007dce",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4198",
    "data-name": "Trazado 4198",
    d: "M192.2,175.533H6.661A5.661,5.661,0,0,1,1,169.872V124.623a5.661,5.661,0,0,1,5.661-5.661H192.2a5.662,5.662,0,0,1,5.661,5.661v45.248a5.662,5.662,0,0,1-5.661,5.661",
    transform: "translate(-35.734 -12.933)",
    fill: "#cde0ee"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2375",
    "data-name": "Rect\\xE1ngulo 2375",
    width: 196.863,
    height: 56.571,
    rx: 5,
    transform: "translate(-34.733 106.029)",
    fill: "none",
    stroke: "#003765",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2376",
    "data-name": "Rect\\xE1ngulo 2376",
    width: 98.387,
    height: 76.556,
    transform: "translate(77.554 216.468)",
    fill: "none",
    stroke: "#007dce",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2377",
    "data-name": "Rect\\xE1ngulo 2377",
    width: 290.19,
    height: 48.5,
    transform: "translate(46.359 348.31)",
    fill: "#006eb2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2378",
    "data-name": "Rect\\xE1ngulo 2378",
    width: 290.19,
    height: 48.5,
    transform: "translate(46.359 348.31)",
    fill: "none",
    stroke: "#007dce",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4199",
    "data-name": "Trazado 4199",
    d: "M331.766,141.636a7.062,7.062,0,0,0-1.187.112,14.973,14.973,0,1,0-26.386-14.125,11.7,11.7,0,0,0-20.738,9.828,9.321,9.321,0,0,0-6.957,9.011c0,4.876,3.742,9.286,8.51,9.286l46.756.041a7.076,7.076,0,1,0,0-14.152",
    transform: "translate(0.709 -12.893)",
    fill: "#88c0ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4200",
    "data-name": "Trazado 4200",
    d: "M331.766,141.636a7.062,7.062,0,0,0-1.187.112,14.973,14.973,0,1,0-26.386-14.125,11.7,11.7,0,0,0-20.738,9.828,9.321,9.321,0,0,0-6.957,9.011c0,4.876,3.742,9.286,8.51,9.286l46.756.041a7.076,7.076,0,1,0,0-14.152Z",
    transform: "translate(0.709 -12.893)",
    fill: "none",
    stroke: "#007dce",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4201",
    "data-name": "Trazado 4201",
    d: "M235.252,86.041h-18.86a10.385,10.385,0,1,1,0-20.769h18.86a10.385,10.385,0,0,1,0,20.769",
    transform: "translate(-8.615 -20.035)",
    fill: "#88c0ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4202",
    "data-name": "Trazado 4202",
    d: "M235.252,86.041h-18.86a10.385,10.385,0,1,1,0-20.769h18.86a10.385,10.385,0,0,1,0,20.769Z",
    transform: "translate(-8.615 -20.035)",
    fill: "none",
    stroke: "#007dce",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4203",
    "data-name": "Trazado 4203",
    d: "M333.752,157.791h-18.86a10.385,10.385,0,1,1,0-20.769h18.86a10.385,10.385,0,0,1,0,20.769",
    transform: "translate(4.414 -10.544)",
    fill: "#88c0ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4204",
    "data-name": "Trazado 4204",
    d: "M333.752,157.791h-18.86a10.385,10.385,0,1,1,0-20.769h18.86a10.385,10.385,0,0,1,0,20.769Z",
    transform: "translate(4.414 -10.544)",
    fill: "none",
    stroke: "#007dce",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4205",
    "data-name": "Trazado 4205",
    d: "M201.954,54.172a26.04,26.04,0,1,1-26.04-26.04,26.04,26.04,0,0,1,26.04,26.04",
    transform: "translate(-16.041 -24.948)",
    fill: "#88c0ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4206",
    "data-name": "Trazado 4206",
    d: "M201.954,54.172a26.04,26.04,0,1,1-26.04-26.04A26.04,26.04,0,0,1,201.954,54.172Z",
    transform: "translate(-16.041 -24.948)",
    fill: "none",
    stroke: "#007dce",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4207",
    "data-name": "Trazado 4207",
    d: "M233.516,68.136a7.06,7.06,0,0,0-1.187.112,14.973,14.973,0,1,0-26.386-14.125,11.7,11.7,0,0,0-20.738,9.828,9.321,9.321,0,0,0-6.957,9.011c0,4.876,3.742,9.286,8.51,9.286l46.756.041a7.076,7.076,0,1,0,0-14.152",
    transform: "translate(-12.287 -22.615)",
    fill: "#88c0ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4208",
    "data-name": "Trazado 4208",
    d: "M233.516,68.136a7.06,7.06,0,0,0-1.187.112,14.973,14.973,0,1,0-26.386-14.125,11.7,11.7,0,0,0-20.738,9.828,9.321,9.321,0,0,0-6.957,9.011c0,4.876,3.742,9.286,8.51,9.286l46.756.041a7.076,7.076,0,1,0,0-14.152Z",
    transform: "translate(-12.287 -22.615)",
    fill: "none",
    stroke: "#007dce",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4209",
    "data-name": "Trazado 4209",
    d: "M244.855,72.513H229.719a6.746,6.746,0,0,1,0-13.491h15.136a6.746,6.746,0,0,1,0,13.491",
    transform: "translate(-6.371 -20.862)",
    fill: "#88c0ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4210",
    "data-name": "Trazado 4210",
    d: "M244.855,72.513H229.719a6.746,6.746,0,0,1,0-13.491h15.136a6.746,6.746,0,0,1,0,13.491Z",
    transform: "translate(-6.371 -20.862)",
    fill: "none",
    stroke: "#007dce",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4211",
    "data-name": "Trazado 4211",
    d: "M312.855,158.763H297.719a6.746,6.746,0,0,1,0-13.491h15.136a6.746,6.746,0,0,1,0,13.491",
    transform: "translate(2.624 -9.453)",
    fill: "#88c0ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4212",
    "data-name": "Trazado 4212",
    d: "M312.855,158.763H297.719a6.746,6.746,0,0,1,0-13.491h15.136a6.746,6.746,0,0,1,0,13.491Z",
    transform: "translate(2.624 -9.453)",
    fill: "none",
    stroke: "#007dce",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_63",
    "data-name": "L\\xEDnea 63",
    x2: 233.701,
    transform: "translate(101.147 348.31)",
    fill: "none",
    stroke: "#007dce",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2607",
    "data-name": "Grupo 2607"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2614",
    "data-name": "Grupo 2614"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4213",
    "data-name": "Trazado 4213",
    d: "M250.621,163.353a1.558,1.558,0,0,0-.4-.868,2.061,2.061,0,0,0,1.312-1.387,1.593,1.593,0,0,0-.246-1.339,2.242,2.242,0,0,0,1.223-.654,1.692,1.692,0,0,0-.1-2.562l-.054-.042a2.272,2.272,0,0,0,1.414-.838,1.688,1.688,0,0,0-.39-2.55L251.2,151.8l2.416-.121a2.241,2.241,0,0,0,2.142-1.987,1.726,1.726,0,0,0-1.936-1.783l-.459.026a1.766,1.766,0,0,0,.008-.641l1.473-.428a2.177,2.177,0,0,0,1.626-2.423,1.672,1.672,0,0,0-1.187-1.247,2.221,2.221,0,0,0,.923-1.458,1.717,1.717,0,0,0-1.786-1.971l-.512,0,.615-.661a1.873,1.873,0,0,0-.025-2.773,2,2,0,0,0-1.782-.31,1.839,1.839,0,0,0-.082-1.584,1.728,1.728,0,0,0-1.21-.832,2.206,2.206,0,0,0,.565-1.33,1.7,1.7,0,0,0-1.223-1.749,2.455,2.455,0,0,0,2.215-1.931,1.74,1.74,0,0,0-1.687-2.129l-2.79-.105,2.294-1.31a2.283,2.283,0,0,0,1.079-2.865,1.931,1.931,0,0,0-2.79-.64l-3.006,1.753,3.472-3.2a2.147,2.147,0,0,0,.354-2.982,1.85,1.85,0,0,0-1.777-.516,2.157,2.157,0,0,0,.16-1.758,1.865,1.865,0,0,0-2.706-.851l-.491.254.262-.891a1.811,1.811,0,0,0-1.4-2.426,2.3,2.3,0,0,0-1.855.619,1.739,1.739,0,0,0-.855-1.346,1.92,1.92,0,0,0-1.555-.122,2.071,2.071,0,0,0-.112-1.44,1.858,1.858,0,0,0-2.76-.6l-1.165.745a2.017,2.017,0,0,0-.506-2.622,2.131,2.131,0,0,0-2.879.778l-1.217,1.784c-.083-.05-.169-.1-.253-.145l1.235-3.078A1.928,1.928,0,0,0,231,102.837a2.054,2.054,0,0,0-1.867.406,1.887,1.887,0,0,0-.65-1.541,2.016,2.016,0,0,0-2.852.567l-.334.442-.161-.863a1.726,1.726,0,0,0-2.348-1.351,2.445,2.445,0,0,0-1.4,1.38,1.648,1.648,0,0,0-1.363-.71,2.1,2.1,0,0,0-1.453.626,1.8,1.8,0,0,0-.729-1.133,1.776,1.776,0,0,0-1.91,0,1.872,1.872,0,0,0-.731-1.4,1.928,1.928,0,0,0-2.719.716l-1.56,2.4-.028,0,.135-2.484a1.775,1.775,0,0,0-1.8-2.015,2.3,2.3,0,0,0-2,2.231l-.1,2.147-.265,0-.567-3.09a1.68,1.68,0,0,0-2.219-1.394,2.252,2.252,0,0,0-1.334,1.363,1.608,1.608,0,0,0-1.312-.772,2.163,2.163,0,0,0-2.054,2.034l-.053.516-.562-.548a1.707,1.707,0,0,0-2.583.323,2.372,2.372,0,0,0-.457,1.809,1.648,1.648,0,0,0-1.455.238,2.223,2.223,0,0,0-.868,1.276,1.537,1.537,0,0,0-1.141-.431,1.718,1.718,0,0,0-.93.35,1.954,1.954,0,0,0-1.878,1.624l-.148.662c-.316.148-.632.3-.943.451l-.214-.659a1.6,1.6,0,0,0-2.239-1.051,2.184,2.184,0,0,0-1.022,2.609l.29.879c-.139.087-.274.18-.412.268l-1-1.607a1.545,1.545,0,0,0-2.385-.376,2.155,2.155,0,0,0-.72,1.629,1.471,1.471,0,0,0-1.387-.18,2.069,2.069,0,0,0-1.131,2.451l.119.455-.662-.263a1.649,1.649,0,0,0-2.132,1.195,2.136,2.136,0,0,0,.178,1.693,1.606,1.606,0,0,0-1.182.719,2.1,2.1,0,0,0-.348,1.389,1.421,1.421,0,0,0-1.122.04,1.932,1.932,0,0,0-.993,2.017,1.512,1.512,0,0,0-2-.819,1.944,1.944,0,0,0-.883,2.4l.753,2.145-.084.051-1.445-1.122a1.443,1.443,0,0,0-2.185.48,2,2,0,0,0,.448,2.509l.653.508c-.1.125-.192.25-.285.382l-1.43-.6a1.471,1.471,0,0,0-1.97,1.053,2.015,2.015,0,0,0,.215,1.616,1.412,1.412,0,0,0-1.127.636,1.948,1.948,0,0,0,.286,2.464l.3.276-.62.17a1.686,1.686,0,0,0-1.048,2.08,1.763,1.763,0,0,0,.917,1.179,1.683,1.683,0,0,0-.557,1.2,1.918,1.918,0,0,0,.384,1.247,1.4,1.4,0,0,0-.828.649,1.865,1.865,0,0,0,.451,2.35l1.555,1.216a1.361,1.361,0,0,0-1.051.674,1.827,1.827,0,0,0,.444,2.316l.863.676c-.059.1-.126.191-.182.3l-1.686-.745a1.346,1.346,0,0,0-1.86.9,1.827,1.827,0,0,0,.215,1.49,1.286,1.286,0,0,0-1.064.546,1.768,1.768,0,0,0,.289,2.271l.288.264-.588.135a1.475,1.475,0,0,0-.982,1.875,1.726,1.726,0,0,0,.88,1.114,1.45,1.45,0,0,0-.521,1.084,1.783,1.783,0,0,0,.371,1.158,1.248,1.248,0,0,0-.78.57,1.712,1.712,0,0,0,.443,2.175l2.179,1.718-.7.115a1.372,1.372,0,0,0-1.028,1.737,1.594,1.594,0,0,0,1.711,1.287l1.147-.181c.02.1.035.19.055.286l-1.675.774a1.439,1.439,0,0,0-.574,1.962,1.637,1.637,0,0,0,1.063.893,1.413,1.413,0,0,0-.309,1.148,1.621,1.621,0,0,0,1.607,1.405l.344-.019-.277.519a1.624,1.624,0,0,0,.583,2.049,1.374,1.374,0,0,0,1.255.171,1.636,1.636,0,0,0,.37,1.158,1.57,1.57,0,0,0,.977.573,1.434,1.434,0,0,0-.122.979,1.6,1.6,0,0,0,1.687,1.273l.943-.118c2.389,2.92,5.2,4.851,8.051,5.331.556.41.871.109.871.109a7.944,7.944,0,0,0,1.383-.023c4.953-.544,8.431-5.734,9.207-12.931a44.929,44.929,0,0,0,10.619,4.77,45.589,45.589,0,0,0,20.426,1.412c-5.039,4.247,16.1,7.778,17.023,5.343a1.932,1.932,0,0,0,1.563.269,1.686,1.686,0,0,0,1.316-2.035l-.238-.838a1.909,1.909,0,0,0,1.858.5,1.729,1.729,0,0,0,1.349-2.07l-.542-1.953,1.814,1.4a2.045,2.045,0,0,0,2.654-.233,1.6,1.6,0,0,0,.308-1.885,2.088,2.088,0,0,0,2.167-.955,1.572,1.572,0,0,0,.063-1.5c.037-.031.079-.054.115-.086a1.63,1.63,0,0,0,.1-2.465l-1-.909,1.961-.309a1.977,1.977,0,0,0,1.746-2.055m-89.281-11.78c0,.031-.008.061-.011.092l-.243-.035Zm79-35.269c-.129-.142-.259-.283-.391-.422l.921-1.441Zm12.147,27.369-.006-.023h.078Zm-4.248,14.618.819.627-1.026-.137c.068-.163.14-.325.207-.49m1.534-19.91L250.4,138l-.624.684c0-.1,0-.2-.008-.3m-1.312-7.935,1.045.046-1.008.088c-.012-.044-.024-.089-.037-.135M246.4,162.223l.114.016-.135.023.02-.038m-.671-43.854-2.139,2.008c-.1-.142-.189-.286-.29-.426a2.386,2.386,0,0,0,.248-.481Zm-18.6-11.737.6-.776-.349.889c-.082-.04-.168-.075-.25-.113m-24.118-4.146-.18.018.068-.616ZM181.8,110.821l-.059.048-.061-.238Zm-19.5,36.1-.311-.285.352.157-.041.128m.217,17.924.234-.106.029.091Zm68.168,4.321q1.688-.854,3.278-1.865l-.986,2.678a7.674,7.674,0,0,0-2.292-.813",
    transform: "translate(20.889 12.922)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4214",
    "data-name": "Trazado 4214",
    d: "M204.429,245.2h-3.8a18.061,18.061,0,0,1-18.061-18.061V194.511H222.49v32.627A18.061,18.061,0,0,1,204.429,245.2",
    transform: "translate(24.15 25.73)",
    fill: "#c2683b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2609",
    "data-name": "Grupo 2609",
    transform: "translate(206.716 220.241)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2608",
    "data-name": "Grupo 2608",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4215",
    "data-name": "Trazado 4215",
    d: "M213.3,224.187h-9.391a19.941,19.941,0,0,1-14.1-5.84l-2.9-2.9a29.977,29.977,0,0,1-8.78-21.2v-58.9H239.08v58.9a29.977,29.977,0,0,1-8.78,21.2l-2.9,2.9a19.939,19.939,0,0,1-14.1,5.84",
    transform: "translate(-183.153 -202.336)",
    fill: "#995230"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2611",
    "data-name": "Grupo 2611"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2613",
    "data-name": "Grupo 2613"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4217",
    "data-name": "Trazado 4217",
    d: "M208.96,218.867h-9.322A20.024,20.024,0,0,1,185.479,213l-2.876-2.875a29.977,29.977,0,0,1-8.78-21.2v-58.9h60.952v58.9a29.978,29.978,0,0,1-8.781,21.2L223.119,213a20.024,20.024,0,0,1-14.159,5.865",
    transform: "translate(22.993 17.201)",
    fill: "#c2683b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4218",
    "data-name": "Trazado 4218",
    d: "M229.731,183.013h2.333a11.121,11.121,0,0,0,11.121-11.121V167.5a6.022,6.022,0,0,0-6.021-6.021h-1.48a8.047,8.047,0,0,0-8.047,8.047v11.4a2.094,2.094,0,0,0,2.095,2.095",
    transform: "translate(30.112 21.36)",
    fill: "#c2683b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4219",
    "data-name": "Trazado 4219",
    d: "M173.527,183.246h-2.332a11.121,11.121,0,0,1-11.121-11.121V167.73a6.022,6.022,0,0,1,6.021-6.021h1.48a8.047,8.047,0,0,1,8.047,8.047v11.4a2.094,2.094,0,0,1-2.095,2.095",
    transform: "translate(21.175 21.391)",
    fill: "#c2683b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4220",
    "data-name": "Trazado 4220",
    d: "M237.614,167.484h0c-3.855.228-6.119,2.5-6.169,6.2l-.007.453",
    transform: "translate(30.615 22.155)",
    fill: "none",
    stroke: "#570f0a",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4221",
    "data-name": "Trazado 4221",
    d: "M163.98,167.324h0c3.855.228,6.119,2.5,6.169,6.2l.007.453",
    transform: "translate(21.691 22.134)",
    fill: "none",
    stroke: "#570f0a",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4222",
    "data-name": "Trazado 4222",
    d: "M218.133,170.049A3.158,3.158,0,1,0,214.4,173a3.38,3.38,0,0,0,3.732-2.952",
    transform: "translate(28.032 21.946)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4223",
    "data-name": "Trazado 4223",
    d: "M192.957,169.135a3.158,3.158,0,1,0-2.717,3.905,3.379,3.379,0,0,0,2.717-3.905",
    transform: "translate(24.698 21.945)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4224",
    "data-name": "Trazado 4224",
    d: "M206.695,183.816h-7.617a.95.95,0,0,1-.908-1.229l3.628-11.848",
    transform: "translate(26.209 22.586)",
    fill: "none",
    stroke: "#d33728",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4225",
    "data-name": "Trazado 4225",
    d: "M197.142,153.755c.031-1.12-3.475-2.126-7.831-2.246s-7.91.69-7.941,1.809Z",
    transform: "translate(23.992 20.04)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4226",
    "data-name": "Trazado 4226",
    d: "M208.549,152.214c.323-1.073,3.968-.927,8.14.326s7.293,3.14,6.97,4.213Z",
    transform: "translate(27.587 20.04)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4227",
    "data-name": "Trazado 4227",
    d: "M216.9,189.889l-1.607.366a62.524,62.524,0,0,1-12.711,3.067l-2.593.11",
    transform: "translate(26.455 25.119)",
    fill: "none",
    stroke: "#6b1c36",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4228",
    "data-name": "Trazado 4228",
    d: "M238.62,139.266s-4.205,13.339-21.774,12.816c-17.609-.524-20.672-21.205-37.766-21.205v-2.33h59.249Z",
    transform: "translate(23.689 17.004)",
    fill: "#995230"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4229",
    "data-name": "Trazado 4229",
    d: "M195.295,142.008l-5.807-1.013a3.283,3.283,0,0,1-2.6-4.245,4.167,4.167,0,0,1,4.57-2.95l5.706.95a3.371,3.371,0,0,1,2.745,4.218,4.116,4.116,0,0,1-4.612,3.04",
    transform: "translate(24.703 17.693)",
    fill: "#995230"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4230",
    "data-name": "Trazado 4230",
    d: "M201.69,139.284l-7.82,4.163a2.371,2.371,0,0,1-3.324-.955,2.614,2.614,0,0,1,1.259-3.348l7.73-4.077a2.419,2.419,0,0,1,3.313.906,2.5,2.5,0,0,1-1.158,3.311",
    transform: "translate(25.177 17.826)",
    fill: "#995230"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4231",
    "data-name": "Trazado 4231",
    d: "M203.053,139.716l-6.827,5.737a2.5,2.5,0,0,1-3.557-.194,2.541,2.541,0,0,1,.487-3.53l6.782-5.623a2.521,2.521,0,0,1,3.5.165,2.421,2.421,0,0,1-.384,3.444",
    transform: "translate(25.419 17.922)",
    fill: "#995230"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4232",
    "data-name": "Trazado 4232",
    d: "M207.857,138.854l-5.986,6.526a2.579,2.579,0,0,1-3.611.277,2.482,2.482,0,0,1-.039-3.543l5.974-6.406a2.585,2.585,0,0,1,3.529-.283,2.364,2.364,0,0,1,.132,3.429",
    transform: "translate(26.125 17.839)",
    fill: "#995230"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4233",
    "data-name": "Trazado 4233",
    d: "M208.856,144.034l-2.956,2.543a2.494,2.494,0,1,1-3.237-3.785L205.6,140.3a2.568,2.568,0,0,1,3.578.181,2.5,2.5,0,0,1-.322,3.553",
    transform: "translate(26.682 18.475)",
    fill: "#995230"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4234",
    "data-name": "Trazado 4234",
    d: "M219.306,149.05l6.285,1.183a3.919,3.919,0,0,0,4.643-3.189,4.039,4.039,0,0,0-3.311-4.571l-6.166-1.109a3.965,3.965,0,0,0-4.6,3.088,3.916,3.916,0,0,0,3.152,4.6",
    transform: "translate(28.583 18.691)",
    fill: "#995230"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4235",
    "data-name": "Trazado 4235",
    d: "M214.1,144.243l5.766,6.84a2.664,2.664,0,0,0,3.757.324,2.625,2.625,0,0,0,.274-3.725l-5.813-6.719a2.616,2.616,0,0,0-3.623-.284,2.506,2.506,0,0,0-.36,3.564",
    transform: "translate(28.244 18.53)",
    fill: "#995230"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4236",
    "data-name": "Trazado 4236",
    d: "M212.5,144.131l4.034,7.954a2.655,2.655,0,1,0,4.715-2.441l-4.131-7.865a2.58,2.58,0,0,0-3.457-1.06,2.547,2.547,0,0,0-1.162,3.412",
    transform: "translate(28.074 18.577)",
    fill: "#995230"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4237",
    "data-name": "Trazado 4237",
    d: "M208.243,141.608l2.782,8.275a2.577,2.577,0,0,0,3.336,1.586,2.657,2.657,0,0,0,1.624-3.367l-2.9-8.215a2.5,2.5,0,0,0-3.221-1.466,2.557,2.557,0,0,0-1.624,3.187",
    transform: "translate(27.53 18.29)",
    fill: "#995230"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4238",
    "data-name": "Trazado 4238",
    d: "M204.747,145.991l1.636,3.43a2.542,2.542,0,0,0,3.486,1.125,2.665,2.665,0,0,0,1.213-3.526l-1.678-3.391a2.515,2.515,0,0,0-3.417-1.071,2.622,2.622,0,0,0-1.24,3.433",
    transform: "translate(27.052 18.82)",
    fill: "#995230"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4239",
    "data-name": "Trazado 4239",
    d: "M203.3,102.117c-.41-.163-.647-.248-.647-.248.216.075.431.162.647.248",
    transform: "translate(26.808 13.475)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4240",
    "data-name": "Trazado 4240",
    d: "M203.65,102.259c-.14-.061-.281-.114-.422-.171l.422.171",
    transform: "translate(26.883 13.504)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4241",
    "data-name": "Trazado 4241",
    d: "M215.51,111.647A55.773,55.773,0,0,0,202.7,104.2c4.706,2.032,8.858,6.528,8.858,11.575l-6.283-11.663s-29.382,10.7-36.809,30.544c-6.947,18.557,6.5,42.812,6.5,42.812s-.868-35.8,14.42-38.721a3.859,3.859,0,0,0,2.353,1.3l1.431.211a2.566,2.566,0,0,0,2.428,2.693,2.558,2.558,0,0,0,4.324,1.71l1.843-1.751a2.559,2.559,0,0,0,4.478,1.491c.183.121.369.241.554.36a2.53,2.53,0,0,0,3.14,1.881c.365.195.729.389,1.1.565l1.088,1.95a2.56,2.56,0,0,0,4.664-.414c.1.007.2.015.3.018l.069.174a2.565,2.565,0,0,0,4.769.007l1.24,2.222a2.556,2.556,0,0,0,4.636-.345,2.567,2.567,0,0,0,3.119-1.848l1.429.224a3.864,3.864,0,0,0,2.684-.571l.918,28.843s8.086-11.779,11.078-23.72c1.531-6.106-3.423-15.041-3.423-25.391,0-23.068-25.019-17.484-28.091-16.711m9.6,12.038c-1.906-4.753.408-10.842-3.32-13.875,2.408.973,3.892,6.73,3.32,13.875",
    transform: "translate(22.021 13.772)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4242",
    "data-name": "Trazado 4242",
    d: "M30.959,221.991l5.422,3.543a13,13,0,0,0,9.5,1.9l16.673-3.117a.589.589,0,0,0,.26-1.037l-2.283-1.835a3.842,3.842,0,0,0-2.422-.847l-4.688.019a5.189,5.189,0,0,1-4.728-7.378,4.218,4.218,0,0,1,5.076-2.25l28.453,8.847A21.58,21.58,0,0,1,95.72,232.089L129.3,312.159l20.152-65.715a33.106,33.106,0,0,1,30.251-23.37l21.388-.9a21.332,21.332,0,0,0,20.635,21.321l1.574.052A23.849,23.849,0,0,0,247.927,219.7l24.842.085a31.027,31.027,0,0,1,27.718,17.3l31.027,62.867,28.761-79.042a22.171,22.171,0,0,1,14.548-13.679l9.2-2.719a30.039,30.039,0,0,1,8.152-1.231h0a2.769,2.769,0,0,1,2.8,2.825v.057a2.771,2.771,0,0,1-1.658,2.493l-8.83,3.868a.587.587,0,0,0,.183,1.123l8.6.77a6.108,6.108,0,0,0,4.3-1.269l12.745-9.95a2.021,2.021,0,0,1,2.8.3l7.512,9.014a2.172,2.172,0,0,1,.012,2.765l-12.509,15.288a6.824,6.824,0,0,1-5.192,2.5l-18.5.242A3.583,3.583,0,0,0,381,236.084l-24.055,104.04c-5.208,22.53-35.533,26.623-46.529,6.281l-20.468-37.866,8.854,84.944L164.758,394.49l8.652-81.519-19.9,41.19c-9.569,19.806-38.295,18.2-45.594-2.553L69.9,243.522a1.907,1.907,0,0,0-2.2-1.231l-19.605,4.246a17.229,17.229,0,0,1-12.038-1.794L21.73,236.752a2,2,0,0,1-.765-2.74L27.3,222.877a2.585,2.585,0,0,1,3.662-.887",
    transform: "translate(2.739 26.822)",
    fill: "#c2683b"
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_64",
    "data-name": "L\\xEDnea 64",
    x1: 6.806,
    y2: 19.122,
    transform: "translate(328.139 328.095)",
    fill: "none",
    stroke: "#1d1d1d",
    strokeWidth: 1.007
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_65",
    "data-name": "L\\xEDnea 65",
    x2: 8.911,
    y2: 20.318,
    transform: "translate(132.728 340.301)",
    fill: "none",
    stroke: "#1d1d1d",
    strokeWidth: 1.007
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4243",
    "data-name": "Trazado 4243",
    d: "M317.839,284.466l-24.225-47.475a37.643,37.643,0,0,0-34.831-20.511l-19.463.674c0,.148.011,1.784.011,1.934a28.135,28.135,0,0,1-56.262.678l-15.859.281a37.643,37.643,0,0,0-35.546,27.362L118.3,294.5l42.518,21.837-8.364,78.822L286.5,394.15l-9.483-85.8Z",
    transform: "translate(15.649 28.633)",
    fill: "#00b1a3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4244",
    "data-name": "Trazado 4244",
    d: "M231,217.055h-7.4c.018.349.023,2.108.023,2.462a20.056,20.056,0,1,1-40.111,0c0-.034,0-.093,0-.144l-8.757.294a28.135,28.135,0,0,0,56.262-.678c0-.149-.009-1.786-.011-1.934",
    transform: "translate(23.116 28.712)",
    fill: "#3e358b"
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_66",
    "data-name": "L\\xEDnea 66",
    x2: 14.446,
    y2: 29.677,
    transform: "translate(277.374 307.293)",
    fill: "none",
    stroke: "#1d1d1d",
    strokeWidth: 1.007
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_67",
    "data-name": "L\\xEDnea 67",
    x1: 3.299,
    y2: 37.66,
    transform: "translate(175.621 307.293)",
    fill: "none",
    stroke: "#1d1d1d",
    strokeWidth: 1.007
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4245",
    "data-name": "Trazado 4245",
    d: "M412.369,97.8V49.439A24.549,24.549,0,0,0,399.783,28L355.175,3.112a24.547,24.547,0,0,0-23.923,0L286.642,28a24.549,24.549,0,0,0-12.585,21.435V97.8a24.548,24.548,0,0,0,12.585,21.435l44.61,24.892a24.547,24.547,0,0,0,23.923,0l44.608-24.892A24.548,24.548,0,0,0,412.369,97.8",
    transform: "translate(36.253 0)",
    fill: "#fc654e"
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_68",
    "data-name": "L\\xEDnea 68",
    x2: 53.54,
    transform: "translate(352.696 99.271)",
    fill: "none",
    stroke: "#fff8ef",
    strokeWidth: 5.254
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_69",
    "data-name": "L\\xEDnea 69",
    x2: 35.693,
    transform: "translate(361.619 112.656)",
    fill: "none",
    stroke: "#ffc6ac",
    strokeWidth: 5.254
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4246",
    "data-name": "Trazado 4246",
    d: "M357.557,58.278A20.078,20.078,0,1,1,337.48,38.2a20.078,20.078,0,0,1,20.078,20.078",
    transform: "translate(41.986 5.053)",
    fill: "#fff8ef"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResults);
export default __webpack_public_path__ + "static/media/NoResults.65965bf37823b0d9dda566972a0237c7.svg";
export { ForwardRef as ReactComponent };